import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import RegistrationImage from '../../../../assets/images/RegistrationLeftImage.png';
import styles from './RegisterLayout.module.scss';

export const RegisterLayout = () => {
  return (
    <Box className={styles.layoutContainer}>
      <img className={styles.registerImage} src={RegistrationImage} />
      <Typography variant='h1' className={styles.welcomeText}>
        Welcome!
      </Typography>
      <Typography variant='h1' className={styles.welcomeText}>
        Benefits HIPAA<span className={styles.link}>LINK</span>
      </Typography>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          Host all your visits from one
          <Typography component='span' fontWeight='bold'>
            custom, secure link
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          Clients check in easily to your
          <Typography component='span' fontWeight='bold'>
            real-time Virtual Waiting Room
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            One-to-one or group sessions
          </Typography>
          for up to
          <Typography component='span' fontWeight='bold'>
            15 participants
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            AI Session Notes
          </Typography>
          automatically generate from
          <Typography component='span' fontWeight='bold'>
            call transcripts
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            Generate your own Notes, powered by AI
          </Typography>
          .
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            Screen sharing, chat, file sharing
          </Typography>
          , and more tools built-in.
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            HIPAA-compliant and end-to-end encrypted
          </Typography>
          for security.
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            Reliable connection
          </Typography>
          —no dropped calls, no interruptions.
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            No downloads required
          </Typography>
          —100% browser-based for you and your clients.
        </Typography>
      </Box>
      <Box className={styles.layoutItem}>
        <CheckIcon />
        <Typography variant='body2'>
          <Typography component='span' fontWeight='bold'>
            Designed for therapists, by therapists
          </Typography>
          , from solo to large practices.
        </Typography>
      </Box>
    </Box>
  );
};
